// Formation modules — positions on a top-down pitch (percent coordinates 0-100)
// PT count is always 1
export const MODULES = {
  "352": { DEF: 3, CEN: 5, ATT: 2 },
  "343": { DEF: 3, CEN: 4, ATT: 3 },
  "451": { DEF: 4, CEN: 5, ATT: 1 },
  "442": { DEF: 4, CEN: 4, ATT: 2 },
  "433": { DEF: 4, CEN: 3, ATT: 3 },
  "532": { DEF: 5, CEN: 3, ATT: 2 },
  "541": { DEF: 5, CEN: 4, ATT: 1 },
};

// Alcuni doc DB storicamente salvano il modulo con i trattini (es. "4-3-3"). Normalizza
// una qualsiasi stringa modulo togliendo i separatori non numerici, con fallback su "442".
export function normalizeModule(mod) {
  if (!mod) return "442";
  const key = String(mod).replace(/[^0-9]/g, "");
  return MODULES[key] ? key : "442";
}

// Return array of slots with {role, index, x%, y%} — top of pitch = attackers (y small), bottom = goalkeeper (y big)
export function slotsForModule(mod) {
  const cfg = MODULES[mod];
  if (!cfg) return [];
  const slots = [];
  // Goalkeeper
  slots.push({ role: "PT", index: 0, y: 90, x: 50 });
  // Defenders
  for (let i = 0; i < cfg.DEF; i++) {
    slots.push({ role: "DEF", index: i, y: 72, x: xForRow(i, cfg.DEF) });
  }
  // Midfielders
  for (let i = 0; i < cfg.CEN; i++) {
    slots.push({ role: "CEN", index: i, y: 48, x: xForRow(i, cfg.CEN) });
  }
  // Attackers
  for (let i = 0; i < cfg.ATT; i++) {
    slots.push({ role: "ATT", index: i, y: 20, x: xForRow(i, cfg.ATT) });
  }
  return slots;
}

function xForRow(i, n) {
  // Spread posizionale sul campo: centrato quando le punte (o difensori) sono poche,
  // così ad esempio i 2 ATT del 442/352/532 stanno sull'asse centrale invece che sui lati.
  if (n === 1) return 50;
  if (n === 2) return i === 0 ? 38 : 62;         // stretti attorno al centro
  if (n === 3) return [26, 50, 74][i];           // triangolo tradizionale
  // n >= 4: spread ampio 12-88
  const start = 12, end = 88;
  return start + ((end - start) * i) / (n - 1);
}

export const REQUIRED_ROSTER = { PT: 4, DEF: 9, CEN: 9, ATT: 7 };
